"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestReport_Operation = exports.TestReport_OperationResultKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var TestReport_OperationResultKind;
(function (TestReport_OperationResultKind) {
    TestReport_OperationResultKind["_pass"] = "pass";
    TestReport_OperationResultKind["_skip"] = "skip";
    TestReport_OperationResultKind["_fail"] = "fail";
    TestReport_OperationResultKind["_warning"] = "warning";
    TestReport_OperationResultKind["_error"] = "error";
})(TestReport_OperationResultKind = exports.TestReport_OperationResultKind || (exports.TestReport_OperationResultKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_TestReport_Operation = t.recursion('ITestReport_Operation', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        result: (0, EnumType_1.createEnumType)(TestReport_OperationResultKind, 'TestReport_OperationResultKind'),
        _result: RTTI_Element_1.RTTI_Element,
        message: RTTI_markdown_1.RTTI_markdown,
        _message: RTTI_Element_1.RTTI_Element,
        detail: RTTI_uri_1.RTTI_uri,
        _detail: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_TestReport_Operation.js.map